const CLIENT_ID_KEY = "tsm_client_id";

function makeClientId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `client-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export function getClientId(): string {
  if (typeof window === "undefined") return "";
  const existing = localStorage.getItem(CLIENT_ID_KEY);
  if (existing && /^[a-zA-Z0-9._:-]{12,120}$/.test(existing)) return existing;
  const next = makeClientId();
  localStorage.setItem(CLIENT_ID_KEY, next);
  return next;
}

export function getClientIdentityHeaders(): Record<string, string> {
  const clientId = getClientId();
  return clientId ? { "X-TSM-Client-ID": clientId } : {};
}
